module.exports = __webpack_public_path__ + "static/media/address.25b9e619.svg";